import { ViewModel, View } from "binder"
import { ChartView } from "./chart-view"
import moment from "moment";
import { ApexOptions } from 'apexcharts'
import { distinct, stringIsNullOrEmpty } from "src/common/utilities";
import { InvertedLuminanceSource } from "@zxing/library";

export class ChartViewModel extends ViewModel {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View<ViewModel> {
        return new ChartView();
    }
    public getTypeId(): string {
        return "VM-2B59694A-F05D-4A25-862A-74EE053697EB"
    }
    public set titlertl(v: boolean) { this._titlertl = v; } public get titlertl(): boolean { return this._titlertl; } private _titlertl: boolean;

    public set series(v: ChartSeries) {
        this._series = v;
        this.internalSeries = this.adaptSeries(v);
    } public get series(): ChartSeries { return this._series; } private _series: ChartSeries;
    public set internalSeries(v: any) { this._internalSeries = v; } public get internalSeries(): any { return this._internalSeries; } private _internalSeries: any;
    public set backgroundStyle(v: string) { this._backgroundStyle = v; } public get backgroundStyle(): string { return this._backgroundStyle; } private _backgroundStyle: string;
    private isInverted(): boolean {
        if (document.body.classList.contains('inverted-theme')) {
            return true;
        }
        return false;
    }
    private swapXAndGroupName(oldSeries: ChartSeries): ChartSeries {
        function groupBy<T, TKey>(list: T[], keyGetter: (obj: T) => TKey): Map<TKey, T[]> {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) {
                    map.set(key, [item]);
                } else {
                    collection.push(item);
                }
            });
            return map;
        }


        var series = <ChartSeries>JSON.parse(JSON.stringify(oldSeries))

        let datum = series.series.flatMap(x => x.data.map(q => {
            return {
                series: x,
                datum: q,
                oldX: q.x,
                newX: x.groupName,
                oldGroupName: x.groupName,
                newGroupName: q.x
            }
        }));
        let newSeries = groupBy(datum, x => x.newGroupName);
        series.series = [];
        newSeries.forEach(x => {
            let ser = new SingleDataSeries();
            ser.groupName = x.at(0).newGroupName.toString();
            ser.name = ser.groupName;
            ser.type = x.at(0).series.type;
            ser.data = x.map(q => {
                let d = new Datum();
                d.x = q.newX;
                d.y = q.datum.y;
                d.y2 = q.datum.y2;
                d.z = q.datum.z;
                return d;
            });
            series.series.push(ser);
        });

        var allKeys = distinct(series.series.flatMap(x => x.data.map(q => q.x))).sort();
        series.series.forEach(s => {
            let newDataArray: Datum[] = [];
            allKeys.forEach(k => {
                let relatedDatum = s.data.filter(x => x.x == k).at(0);
                if (relatedDatum) {
                    newDataArray.push(relatedDatum);
                } else {
                    let newDatum = new Datum();
                    newDatum.x = k;
                    newDatum.y = 0;
                    newDatum.y2 = 0;
                    newDatum.z = 0;
                    newDataArray.push(newDatum);
                }
            });
            s.data = newDataArray;
        })

        return series;
    }
    private adaptSeries(series: ChartSeries): any {
        if (series.shallSwapGroupNameAndDatumX) {
            series = this.swapXAndGroupName(series);
        }
        this.backgroundStyle = null;
        let result = <ApexOptions>new ChartOptionsAdapterFactory().getAdapter(series)?.adapt(series);
        this.backgroundStyle = new ChartOptionsAdapterFactory().getAdapter(series)?.adaptBackground(series)
        result.theme = {
            mode: this.isInverted() ? "light" : "dark"
        };
        if (result.chart == null) {
            result.chart = {};
        }
        if (result.chart.background == null) {
            if (series.background) {
                result.chart.background = series.background;
            } else {
                result.chart.background = "transparent";
            }
        } else {

        }
        result.chart.animations = {
            enabled: true
        };
        if (series.formatter) {
            if (result.dataLabels == null) {
                result.dataLabels = {};
            }
            result.dataLabels.formatter = series.formatter;
        }
        result.chart.toolbar = {
            show: true,
            tools: {
                pan: true,
                zoom: true,
                zoomin: true,
                zoomout: true
            }
        }
        result.chart.zoom = {
            enabled: true
        }
        if (series.chartTitle) {
            result.title = {};
            if (series.chartTitle.title) {
                result.chart.toolbar.export = {
                    csv: {
                        filename: `${series.chartTitle.title}.csv`
                    }
                }
            }
            if (series.chartTitle.title) {
                if (series.chartTitle.titlertl) {
                    result.title.text = `\u202B${series.chartTitle.title}\u202C`;
                } else {
                    result.title.text = series.chartTitle.title;
                }
            }
            if (series.chartTitle.align) result.title.align = series.chartTitle.align;
            if (series.chartTitle.fontSize || series.chartTitle.fontWeight || series.chartTitle.textColor) {
                result.title.style = {};
            }
            if (series.chartTitle.fontSize) {
                result.title.style.fontSize = series.chartTitle.fontSize;
                console.log(series.chartTitle.fontSize)
            }
            if (series.chartTitle.fontWeight) result.title.style.fontWeight = series.chartTitle.fontWeight;
            if (series.chartTitle.textColor) result.title.style.color = series.chartTitle.textColor;
        }

        let annotations = new AnnotationAdapter().adaptAnnotaions(series);
        result.annotations = annotations;
        return result;
    }
}
class AnnotationAdapter implements IAnnotationVisitor {

    private result: any;
    public adaptAnnotaions(series: ChartSeries): any {
        this.result = {
            yaxis: [],
            xaxis: [],
            points: []
        }
        if (series.annotations) {
            series.annotations.forEach(z => {
                if (z.annotationType == "point") {
                    this.visitPointAnnotation(z, null);
                } else if (z.annotationType == "xaxis") {
                    this.visitXAxisAnnotation(z, null);
                } else {
                    this.visitYAxisAnnotation(z, null);
                }
            });
        }
        return this.result;
    }
    visitPointAnnotation(arg0: PointAnnotation, paramter: any): any {
        let result: any = {};
        result.marker = {};
        result.label = {};
        result.label.style = {};

        if (arg0.x) result.x = arg0.x;
        if (arg0.y) result.y = arg0.y;
        if (arg0.size) result.marker.size = arg0.size;
        if (arg0.radius) result.marker.radius = arg0.radius;
        if (arg0.fillColor) result.marker.fillColor = arg0.fillColor;
        if (arg0.strokeColor) result.marker.strokeColor = arg0.strokeColor;
        if (arg0.strokeWidth) result.marker.strokeWidth = arg0.strokeWidth;
        if (arg0.shape) result.marker.shape = arg0.shape;
        if (arg0.markerCssClass) result.marker.CssClass = arg0.markerCssClass;
        if (arg0.text) result.label.text = arg0.text;
        if (arg0.textBorderColor) result.label.borderColor = arg0.textBorderColor;
        if (arg0.textBorderWidth) result.label.borderWidth = arg0.textBorderWidth;
        if (arg0.textBackground) result.label.style.background = arg0.textBackground;
        if (arg0.textColor) result.label.style.color = arg0.textColor;
        if (arg0.textFontSize) result.label.style.fontSize = arg0.textFontSize;
        if (arg0.textFontWeight) result.label.style.fontWeight = arg0.textFontWeight;
        if (arg0.textCssClass) result.label.style.cssClass = arg0.textCssClass;

        this.result.points.push(result);
    }

    visitXAxisAnnotation(arg0: XAxisAnnotation, paramter: any): any {
        let result: any = {};
        result.label = {};
        result.label.style = {};

        if (arg0.x) result.x = arg0.x;
        if (arg0.x2) result.x2 = arg0.x2;
        if (arg0.borderColor) result.borderColor = arg0.borderColor;
        if (arg0.fillColor) result.fillColor = arg0.fillColor;
        if (arg0.opacity) result.opacity = arg0.opacity;
        if (arg0.text) result.label.text = arg0.text;
        if (arg0.textBorderColor) result.label.borderColor = arg0.textBorderColor;
        if (arg0.textBorderWidth) result.label.borderWidth = arg0.textBorderWidth;
        if (arg0.textBackground) result.label.style.background = arg0.textBackground;
        if (arg0.textColor) result.label.style.color = arg0.textColor;
        if (arg0.textFontSize) result.label.style.fontSize = arg0.textFontSize;
        if (arg0.textFontWeight) result.label.style.fontWeight = arg0.textFontWeight;
        if (arg0.textCssClass) result.label.style.cssClass = arg0.textCssClass;

        this.result.xaxis.push(result);

    }
    visitYAxisAnnotation(arg0: YAxisAnnotation, paramter: any): any {
        let result: any = {};
        result.label = {};
        result.label.style = {};

        if (arg0.y) result.y = arg0.y;
        if (arg0.y2) result.y2 = arg0.y2;
        if (arg0.width) result.width = arg0.width;
        if (arg0.borderColor) result.borderColor = arg0.borderColor;
        if (arg0.fillColor) result.fillColor = arg0.fillColor;
        if (arg0.opacity) result.opacity = arg0.opacity;
        if (arg0.text) result.label.text = arg0.text;
        if (arg0.textBorderColor) result.label.borderColor = arg0.textBorderColor;
        if (arg0.textBorderWidth) result.label.borderWidth = arg0.textBorderWidth;
        if (arg0.textBackground) result.label.style.background = arg0.textBackground;
        if (arg0.textColor) result.label.style.color = arg0.textColor;
        if (arg0.textFontSize) result.label.style.fontSize = arg0.textFontSize;
        if (arg0.textFontWeight) result.label.style.fontWeight = arg0.textFontWeight;
        if (arg0.textCssClass) result.label.style.cssClass = arg0.textCssClass;

        this.result.yaxis.push(result);
    }

}
export type ChartTypes = 'line' | 'area' | 'bar' | 'column' | 'pie' | 'doughnut' | 'scatter' | 'bubble' | 'radar' | 'progress' | 'bullet' | 'radial' | "mixed";
export type MixedChartTypes = 'line' | 'area' | 'column';

export class ChartSeries {
    public series: SingleDataSeries[] = [];
    public chartType: ChartTypes;
    public annotations?: AnnotationType[] = [];
    public background?: string;
    public chartTitle?: ChartTitleInfo;
    public stacked?: boolean;
    public shallSwapGroupNameAndDatumX?: boolean;
    public formatter?: (val: any) => any;
    public isBarChartDataLabelsVertical?: boolean;
}

export class ChartTitleInfo {
    public title?: string;
    public align?: 'left' | 'right' | 'center' = 'center';
    public fontSize?: string;
    public fontWeight?: string;
    public textColor?: string;
    public titlertl?: boolean = false;
}

export class BulletChartStops {
    public stops: SingleBulletChartStop[] = [];
}
export class SingleBulletChartStop {
    public untilPecentage: number;
    public color: string;
}

interface IAnnotationVisitor {
    visitXAxisAnnotation(arg0: XAxisAnnotation, paramter: any): any;
    visitYAxisAnnotation(arg0: YAxisAnnotation, paramter: any): any;
    visitPointAnnotation(arg0: PointAnnotation, paramter: any): any;

}
export type AnnotationType = PointAnnotation | XAxisAnnotation | YAxisAnnotation;
export interface IAnnotations {
    Accept(visitor: IAnnotationVisitor, paramter: any): any;
}

export class PointAnnotation implements IAnnotations {
    public annotationType: "point" = "point";
    public x: number;
    public y: number;
    public size: number;
    public radius: number;
    public fillColor: string;
    public strokeColor: string;
    public strokeWidth: number;
    public shape: "circle" | "square";
    public markerCssClass: string;
    public text: string;
    public textBorderColor: string;
    public textBorderWidth: number;
    public textBackground: string;
    public textColor: string;
    public textFontSize: string;
    public textFontWeight: string;
    public textCssClass: string;

    Accept(visitor: IAnnotationVisitor, paramter: any) {
        return visitor.visitPointAnnotation(this, paramter);
    }

}
export abstract class AxisAnnotation implements IAnnotations {
    abstract Accept(visitor: IAnnotationVisitor, paramter: any);
    public borderColor: string;
    public fillColor: string;
    public opacity: number;
    public text: string;
    public textBorderColor: string;
    public textBorderWidth: number;
    public textBackground: string;
    public textColor: string;
    public textFontSize: string;
    public textFontWeight: string;
    public textCssClass: string;
}
export class YAxisAnnotation extends AxisAnnotation {
    public annotationType: "yaxis" = "yaxis";
    public y: number;
    public y2: number;
    public width: string;
    Accept(visitor: IAnnotationVisitor, paramter: any) {
        return visitor.visitYAxisAnnotation(this, paramter);
    }

}
export class XAxisAnnotation extends AxisAnnotation {
    public annotationType: "xaxis" = "xaxis";
    public x: number;
    public x2: number;

    Accept(visitor: IAnnotationVisitor, paramter: any) {
        return visitor.visitXAxisAnnotation(this, paramter);
    }

}

export class SingleDataSeries {
    public name: string;
    public groupName: string;
    public data: Datum[] = [];
    public type?: MixedChartTypes;
    public bulletChartStops: BulletChartStops;
    public progressAndBulletHorizontal: boolean = true;
}

export class Datum {
    public x: number | string | moment.Moment | null;
    public y: number;
    public y2: number;
    public z: number;
}
class ChartOptionsAdapterFactory {
    getAdapter(series: ChartSeries): IChartOptionsAdapter {
        if (series.chartType == "line") {
            return new LinearAdapter();
        } else if (series.chartType == 'bar') {
            return new BarAdapter();
        } else if (series.chartType == 'column') {
            return new ColumnAdapter();
        } else if (series.chartType == 'pie') {
            return new PieAdapter();
        } else if (series.chartType == 'doughnut') {
            return new DoughnutAdapter();
        } else if (series.chartType == 'area') {
            return new AreaAdapter();
        } else if (series.chartType == 'scatter') {
            return new ScatterAdapter();
        } else if (series.chartType == 'bubble') {
            return new BubbleAdapter();
        } else if (series.chartType == 'radar') {
            return new RadarAdapter();
        } else if (series.chartType == 'progress') {
            return new ProgressAdapter();
        } else if (series.chartType == 'mixed') {
            return new MixedAdapter();
        } else if (series.chartType == "bullet") {
            return new BulletAdapter();
        } else if (series.chartType == 'radial') {
            return new RadialAdapter();
        }
        return null;
    }
}



interface IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string;
    adapt(series: ChartSeries): any;
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean): any;
}
function getSeriesXAxisType(series: ChartSeries): "category" | "numeric" | "datetime" {
    let firstValue = series.series.at(0)?.data.at(0)?.x;
    if (firstValue == null)
        return "category"
    else if (typeof firstValue == "string")
        return "category";
    else if (typeof firstValue == "number" || typeof firstValue == "bigint")
        return "numeric";
    else
        return "datetime";
}


class MixedAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        let adapter: IChartOptionsAdapter;
        if (series.type == "line") {
            adapter = new LinearAdapter();
        } else if (series.type == "area") {
            adapter = new AreaAdapter();
        } else if (series.type == "column") {
            adapter = new ColumnAdapter();
        }
        return adapter.adaptSeries(series, includeChartType, includeGrouping);
    }

    adapt(series: ChartSeries) {
        let needsGrouping = false;
        if (series.series.filter(x => stringIsNullOrEmpty(x.groupName) == false).length >= 2) {
            needsGrouping = true;
        }
        let a /*: ApexOptions*/ = {
            series: series.series.map(x => {
                return this.adaptSeries(x, true, needsGrouping && !(series.stacked ?? false));
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }

}
class LinearAdapter implements IChartOptionsAdapter {
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        return {
            name: series.name,
            data: series.data.map(q => { return { x: q.x, y: q.y }; }),
            type: includeChartType ? "line" : undefined
        }
    }
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'line'
            },
            series: series.series.map(x => {
                return this.adaptSeries(x, false, false);
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }
}

class ColumnAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        return {
            name: series.name,
            group: includeGrouping ? series.groupName : undefined,
            data: series.data.map(q => { return { x: q.x, y: q.y }; }),
            type: includeChartType ? "bar" : undefined
        }
    }
    private isInverted(): boolean {
        if (document.body.classList.contains('inverted-theme')) {
            return true;
        }
        return false;
    }

    adapt(series: ChartSeries) {
        let needsGrouping = false;
        if (series.series.filter(x => stringIsNullOrEmpty(x.groupName) == false).length >= 2) {
            needsGrouping = true;
        }
        let a: ApexOptions = {
            chart: {
                type: 'bar',
                stacked: needsGrouping
            },
            series: series.series.map(x => {
                return this.adaptSeries(x, false, needsGrouping && !(series.stacked ?? false))
            }),
            xaxis: {
                type: getSeriesXAxisType(series),
                labels: {
                    style: {
                        cssClass: "apexcharts-xaxis-label-style"
                    },
                    hideOverlappingLabels: false,
                    show: true
                }
            }
        };
        if (series.isBarChartDataLabelsVertical === true) {
            if (a.plotOptions == null) {
                a.plotOptions = {
                    bar: {
                        dataLabels: {
                            orientation: "vertical",
                            position: "top"
                        }   
                    }
                }
            } else {
                a.plotOptions.bar.dataLabels.orientation = "vertical";
            }
        }
        if (series.stacked) {
            a.plotOptions = {
                bar: {
                    dataLabels: {
                        total: {
                            enabled: true,
                            style: {
                                color: this.isInverted() ? "black" : 'white',
                                fontSize: '12px',
                                fontWeight: 900
                            }
                        }
                    }
                }
            };
        }
        return a;
    }
}

class BarAdapter implements IChartOptionsAdapter {
    private isInverted(): boolean {
        if (document.body.classList.contains('inverted-theme')) {
            return true;
        }
        return false;
    }

    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        return {
            name: series.name,
            group: includeGrouping ? series.groupName : undefined,
            data: series.data.map(q => { return { x: q.x, y: q.y }; }),
            type: includeChartType ? "bar" : undefined
        }
    }
    adapt(series: ChartSeries) {
        let needsGrouping = false;
        if (series.series.filter(x => stringIsNullOrEmpty(x.groupName) == false).length >= 2) {
            needsGrouping = true;
        }
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'bar',
                stacked: needsGrouping
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                }
            },
            series: series.series.map(x => {
                return this.adaptSeries(x, false, needsGrouping && !(series.stacked ?? false));
            })
        };
        if (series.stacked) {
            (<any>(a.plotOptions.bar)).dataLabels = {
                total: {
                    enabled: true,
                    style: {
                        color: this.isInverted() ? "black" : 'white',
                        fontSize: '13px',
                        fontWeight: 900
                    }
                }
            }
        }
        return a;
    }
}

class PieAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'pie'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                }
            },
            series: series.series.at(0)?.data.map(x => x.y) ?? [],
            labels: series.series.at(0)?.data.map(x => x.x) ?? []
        };

        return a;
    }
}
class DoughnutAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'donut'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                }
            },
            series: series.series.at(0)?.data.map(x => x.y) ?? [],
            labels: series.series.at(0)?.data.map(x => x.x) ?? []
        };

        return a;
    }
}

class AreaAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        return {
            name: series.name,
            group: includeGrouping ? series.groupName : undefined,
            data: series.data.map(q => { return { x: q.x, y: q.y }; }),
            type: includeChartType ? "area" : undefined
        }
    }
    adapt(series: ChartSeries) {
        let needsGrouping = false;
        if (series.series.filter(x => stringIsNullOrEmpty(x.groupName) == false).length >= 2) {
            needsGrouping = true;
        }

        let a /*: ApexOptions*/ = {
            chart: {
                type: 'area',
                stacked: needsGrouping
            },
            series: series.series.map(x => {
                return this.adaptSeries(x, false, needsGrouping && !(series.stacked ?? false));
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }
}
class ScatterAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {

        let a /*: ApexOptions*/ = {
            chart: {
                type: 'scatter'
            },
            series: series.series.map(x => {
                return {
                    name: x.name,
                    data: x.data.map(q => { return { x: q.x, y: q.y }; }),
                }
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }
}
class BubbleAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'bubble'
            },
            series: series.series.map(x => {
                return {
                    name: x.name,
                    data: x.data.map(q => { return { x: q.x, y: q.y, z: q.z }; }),
                }
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }
}

class RadarAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'radar'
            },
            series: series.series.map(x => {
                return {
                    name: x.name,
                    data: x.data.map(q => { return { x: q.x, y: q.y }; }),
                }
            }),
            xaxis: {
                type: getSeriesXAxisType(series)
            }
        };

        return a;
    }
}


class BulletAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        let stops = series.series.at(0)?.bulletChartStops?.stops ?? [];
        if (stops.length == 0)
            return null;
        let result = [];
        let horizontal = series.series.at(0)?.progressAndBulletHorizontal ?? true;
        if (horizontal == true) {
            result.push("linear-gradient(90deg ")
        } else {
            result.push("linear-gradient(0deg ")
        }

        result.push(`${stops[0].color} 0%`);
        for (let i = 1; i < stops.length; i++) {
            result.push(`${stops[i - 1].color} ${stops[i - 1].untilPecentage}%`);
            result.push(`${stops[i].color} ${stops[i - 1].untilPecentage}%`);
        }
        result.push(`${stops[stops.length - 1].color} ${stops[stops.length - 1].untilPecentage}%)`);
        let finalResult = result.join(", ");
        return finalResult;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }

    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'bar',
                height: 300
            },
            plotOptions: {
                bar: {
                    horizontal: series.series.at(0)?.progressAndBulletHorizontal ?? true,
                    barHeight: "20%",
                    columnWidth: "20%",
                }
            },
            stroke: {
                width: 0
            },
            labels: [
                series.series.at(0)?.name ?? ""
            ],
            series: [
                {
                    name: series.series.at(0)?.name ?? "",
                    data: [series.series.at(0)?.data.at(0)?.y ?? 0],
                }
            ],
            title: {
                floating: true,
                offsetX: -10,
                offsetY: 5,
                text: series.series.at(0)?.name ?? ""
            },
            subtitle: {
                floating: true,
                align: "right",
                offsetY: 0,
                text: `${series.series.at(0)?.data.at(0)?.y ?? 0}%`,
                style: {
                    fontSize: "20px"
                }
            },
            tooltip: {
                enabled: false
            },
            yaxis: {
                max: 100
            },
            fill: {
                opacity: 1
            }
        };

        return a;
    }

}

class RadialAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adapt(series: ChartSeries) {
        var options = {
            series: [series.series.at(0)?.data.at(0)?.y ?? 0],
            chart: {
                height: 350,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '70%',
                    }
                },
            },
            labels: [series.series.at(0)?.name ?? ''],
        };
        return options;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }

}

class ProgressAdapter implements IChartOptionsAdapter {
    adaptBackground(series: ChartSeries): string {
        return null;
    }
    adaptSeries(series: SingleDataSeries, includeChartType: boolean, includeGrouping: boolean) {
        throw new Error("Method not implemented.");
    }
    adapt(series: ChartSeries) {
        let a /*: ApexOptions*/ = {
            chart: {
                type: 'bar',
                stacked: true,
                sparkline: {
                    enabled: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: series.series.at(0)?.progressAndBulletHorizontal ?? true,
                    barHeight: "20%",
                    columnWidth: "20%",
                }
            },
            stroke: {
                width: 0
            },
            series: [
                {
                    name: series.series.at(0)?.name ?? "",
                    data: [series.series.at(0)?.data.at(0)?.y ?? 0],
                }
            ],
            labels: [
                series.series.at(0)?.name ?? ""
            ],
            title: {
                floating: true,
                offsetX: -10,
                offsetY: 5,
                text: series.series.at(0)?.name ?? ""
            },
            subtitle: {
                floating: true,
                align: "right",
                offsetY: 0,
                text: `${series.series.at(0)?.data.at(0)?.y ?? 0}%`,
                style: {
                    fontSize: "20px"
                }
            },
            tooltip: {
                enabled: false
            },
            yaxis: {
                max: 100
            },
            fill: {
                opacity: 1
            }
        };

        return a;
    }
} 
